import styled, { css } from 'styled-components';
import '../../mixins/media.js';
import { keyboardFocusShadowAfter } from '../../mixins/keyboardFocus.js';
import '../../mixins/markStyle.js';
import '../../mixins/scrollbarStyle.js';
import '../../mixins/textStyle.js';
import { COLUMN_AUTO_SIZE } from './Table.constants.js';

const Th = styled.th.withConfig({
  componentId: "sc-1nu2xyy-0"
})(["", " box-sizing:border-box;text-align:left;white-space:nowrap;vertical-align:middle;user-select:none;cursor:", ";padding:", ";", ""], ({
  colSize
}) => colSize && colSize !== COLUMN_AUTO_SIZE && css(["width:", "px;"], colSize), ({
  canSort
}) => canSort ? 'pointer' : 'normal', ({
  theme,
  isCheckboxColumn
}) => isCheckboxColumn ? theme.components.table.checkboxColumnPadding : theme.components.table.thPadding, keyboardFocusShadowAfter({
  offset: 10
}));

export { Th };
//# sourceMappingURL=Th.js.map
